var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"bz-view"},_vm._l((_vm.articleList),function(article){return _c('div',{key:article.id},[(article.editing)?_c('bz-editor',{attrs:{"id":article.id}}):_c('bz-article',{attrs:{"id":article.id}})],1)}))}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-95da43f0","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./~/vue-loader/lib/template-compiler/preprocessor.js?engine=slm!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/BzView.vue
// module id = bNWe
// module chunks = 1